<script>
import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: {
    result: Object
  },
  mounted () {
    this.gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450)
    this.gradient2 = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450)
    this.gradient3 = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450)

    this.gradient.addColorStop(1, 'rgba(30,112,179,0.4)')
    // this.gradient2.addColorStop(1, 'rgba(32,84,141,0.25)')
    this.gradient2.addColorStop(1, 'rgba(14,121,129,0.25)')
    this.gradient3.addColorStop(1, 'rgba(56,109,157,0.35)')

    const date = Object.keys(this.result.revenue)

    const revenue = Object.values(this.result.revenue)
    const historicalRevenue = Object.values(this.result.historical_revenue)

    this.renderChart({
      labels: date,
      datasets: [
        {
          label: 'Omzet',
          // borderColor: '#6fccdd',
          borderColor: '#1e70b3',
          borderWidth: 2,
          backgroundColor: this.gradient,
          data: revenue,
          fill: false
        },
        {
          label: 'Omzet vorig jaar',
          // borderColor: '#6fccdd',
          borderColor: '#1e7033',
          borderWidth: 2,
          backgroundColor: this.gradient2,
          data: historicalRevenue,
          fill: false
        }
      ]
    },
      {
        scales: {
          yAxes: [{
          // stacked: true,
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              display: true
            },
            scaleLabel: {
              display: true,
              labelString: 'Omzet',
              fontColor: '#74788d',
              fontSize: 13,
              fontWeight: 400
            }
          }],
          xAxes: [{
            gridLines: {
              display: false
            },
            type: 'time',
            time: {
              unit: 'day',
              displayFormats: {
                day: 'DD MMM'
              }
            },
            ticks: {
              autoSkip: true,
              minRotation: 30
            }
          }]
        },
        legend: {
          display: true,
          labels: {
            fontColor: '#74788d',
            fontSize: 13,
            fontWeight: 400
          }
        },
        elements: {
          point: {
            radius: 0
          }
        },
        responsive: true,
        maintainAspectRatio: false
      })
  }
}
</script>



// WEBPACK FOOTER //
// LineChart.vue?3b92c3f8